import * as angular from 'angular';
import * as considerEarthquakeCoverageSectionComponent from './consider-earthquake-coverage-section';
import * as protectHighValueItemsSectionComponent from './protect-high-value-items-section';
import * as EarthquakeContactMeCardComponent from './earthquake-contact-me-card';
import * as WindCoverageContactMeCardComponent from './wind-coverage-contact-me-card';
import * as AddWindCoverageSection from './add-wind-coverage-section';
import * as OptionalFloodInsuranceSectionComponent from './optional-flood-insurance-section';
import * as FloodContactMeCardComponent from './flood-contact-me-card';

const module = angular.module('get-more-page-components', [
    considerEarthquakeCoverageSectionComponent.module.name,
    protectHighValueItemsSectionComponent.module.name,
    EarthquakeContactMeCardComponent.module.name,
    WindCoverageContactMeCardComponent.module.name,
    AddWindCoverageSection.module.name,
    OptionalFloodInsuranceSectionComponent.module.name,
    FloodContactMeCardComponent.module.name
]);

export { module };
